import type { User } from "~/types/user";

export function isGuestUser(user: User | null | undefined) {
  if (!user) {
    return true;
  }
  const email = user.basicInfo?.email;
  if (!email) {
    return true;
  }
  return email.endsWith("@fake.email");
}
